import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import _ from "lodash";
import {
  getPopularFreeCourses,
  getPopularFreeCoursesClear,
} from "../../../redux/courses/actions";
import {
  PriceForSession,
  ProductCardPriceInfo,
  PurchasedOn,
  SessionKeys,
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeInHourAndMin,
  getProcureInfo,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router";
import CommonComponentEntity from "./CommonComponentEntity";
import {
  getAllCertifications,
  getAllCertificationsClear,
  getPopularCertifications,
} from "../../../redux/certificateURL/actions";

const PopularCertifications = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const certificationsListRes = useSelector(
    (state) => state.certificateURL.popularCertifications
  );
  console.log("ce--", certificationsListRes);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetchCertifications();
    return () => {
      dispatch(getAllCertificationsClear());
    };
  }, []);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const navigateToView = (data) => {
    let paramsReq ={
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
      is_home: true,
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/event-detail?c=${encodedUrl}`;
    // url = url + `&event_code=${data?.event_code}` + `&source=${data.source}`;
    navigate(url);
  };

  const [userCount, setUserCount] = useState();

  const formatDataForProductCard = (certificatList) => {
    let certificationArr = [];
    let records = certificatList.records;
    for (let item of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      // logoURL = item.logoURL;
      // tags.push(item?.origin);
      // tags.push(item.delivery_mode);
      // tags.push(convertTimeInHourAndMin(item.duration));

      let footerComp = "";

      certificationArr.push({
        id: item?.event_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: item?.type,
        productOrigin: item?.source,
        title: item.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description,
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        // showProviderIcon: true,
        showPlayButton: false,
        showProgress: false,
        showLikeMenu: true,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToView(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isLoading: false,
      });
    }
    console.log("cee--", certificationArr);
    setNewCardData(certificationArr);
  };

  useEffect(() => {
    console.log("cer--", certificationsListRes);
    if (
      !_.isEmpty(certificationsListRes) &&
      certificationsListRes?.status === "success"
    ) {
      let certificationsListDetail = certificationsListRes.payload.payload;
      if (!_.isEmpty(certificationsListDetail)) {
        formatDataForProductCard(certificationsListDetail);
        setUserCount(certificationsListRes.payload?.user_count)
        setIsLoading(false);
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    } else {
      setNewCardData([]);
      setIsLoading(false);
    }
  }, [certificationsListRes]);

  const fetchCertifications = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getPopularCertifications({
        module: "getPopularCertifications",
        postData: {
          token: "",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        // isLoading={isLoading}
        newCardData={newCardData}
        heading={"Popular certifications"}
        subHeading={`👍🏻 ${userCount > 10 ? userCount : "10"}+ learners have been certified`}
        viewAllAction={"/learn/certifications"}
        type={"certificate"}
      />
    </>
  );
};

export default PopularCertifications;
